import React from 'react';

interface Props {
    className?: string;
}

export default function WarnIcon(props: Props) {
    const {className} = props;

    return (
        <svg
            width='28'
            height='28'
            viewBox='0 0 28 28'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <circle cx='14' cy='14' r='14' fill='#FFEA8A' />
            <circle cx='14' cy='14' r='9' fill='white' />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14 4C8.486 4 4 8.486 4 14C4 19.514 8.486 24 14 24C19.514 24 24 19.514 24 14C24 8.486 19.514 4 14 4ZM14 22C9.589 22 6 18.411 6 14C6 9.589 9.589 6 14 6C18.411 6 22 9.589 22 14C22 18.411 18.411 22 14 22ZM14 15C14.553 15 15 14.553 15 14V10C15 9.447 14.553 9 14 9C13.447 9 13 9.447 13 10V14C13 14.553 13.447 15 14 15ZM14 16.9004C13.393 16.9004 12.9 17.3924 12.9 18.0004C12.9 18.6074 13.393 19.0994 14 19.0994C14.607 19.0994 15.1 18.6074 15.1 18.0004C15.1 17.3924 14.607 16.9004 14 16.9004Z'
                fill='#9C6F19'
            />
        </svg>
    );
}
